import React from 'react'

const BMPHelp = () => {
  return (
    <div>
      help
    </div>
  )
}

export default BMPHelp
